<template>
  <div id="manageTransportDriver" class="Content-Page">
    <div id="namePage" class="wrap-Main">
      <div class="box-S4 flex-between-center">
        <div class="N-Page T-size-36">Manage File Video</div>
        <v-btn class="theme-btn-even" @click.stop="addItem()">
          <span class="I-create"></span>
          <span>Add File Video</span>
        </v-btn>
      </div>
    </div>
    <div id="tableData" class="wrap-Main">
      <div class="box-S4">
        <v-data-table :headers="headers" :items="items">
          <template v-slot:item.tsd_photo_url="{ item }">
            <img class="B-display" :src="item.tsd_photo_url" />
          </template>
          <template v-slot:item.tsd_active="{ item }" class="text-xs-right">
            <v-icon v-if="item.tsd_active == true">mdi-check</v-icon>
            <v-icon v-else>mdi-close</v-icon>
          </template>
          <template v-slot:item.action="{ item }">
            <div class="b-action">
              <div class="b-btn">
                <v-btn fab class="btn-edit" @click="editItem(item)">
                  <span class="I-edit"></span>
                </v-btn>
                <v-btn fab class="primary btn-delete" @click="deleteItem(item)">
                  <span class="I-bin"></span>
                </v-btn>
              </div>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
    <!-- dialog สำหรับ เพิ่ม แก้ไข -->
    <v-dialog v-model="dialog" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <!-- set form กรอกข้อมูลที่นี้ -->
              <v-flex xs12>
                <v-text-field
                  v-model="formModel.v_name"
                  label="Video Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="formModel.v_file_name"
                  label="File paths"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="formModel.v_second"
                  label="Time (Second)"
                  type="number"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <!-- <v-checkbox v-model="formModel.v_active" label="Active"></v-checkbox> -->
                <v-select
                  :items="itemsListStatus"
                  item-text="Status"
                  item-value="Status"
                  v-model="formModel.v_active"
                  class="hideMessage"
                  label="Status"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog">Cancel</v-btn>
          <v-btn :loading="loading" @click="saveToServer">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog สำหรับลบ -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Delete Confirmation</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                >Delete "{{ formModel[Object.keys(formModel)[1]] }}" ?</v-flex
              >
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog">Cancel</v-btn>
          <v-btn :loading="loading" @click="deleteToServer">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div id="partBack" class="wrap-Main">
      <div class="line"></div>
      <div class="box-S4">
        <v-btn text class="ColorTheme-S white--text theme-btn" @click="Back()">
          <span class="I-back"></span>
          <span>Back</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>


<script>
import feathersClientUOA from "../plugins/feathers-client-uoa";
import upload from "../utils/upload";

export default {
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    headers: [
      // { value: "tsd_photo_url", text: "", sortable: true },
      { value: "v_name", text: "FIle Name", sortable: true },
      { value: "v_file_name", text: "File Paths", sortable: true },
      { value: "v_second", text: "Time (Second)", sortable: true },
      { value: "v_active", text: "Status", sortable: true },
      { value: "action", text: "", sortable: false },
    ],
    defaultValue: {
      v_name: "",
      v_file_name: "",
      v_second: "",
      v_active: "Active",
    },
    items: [],
    loading: false,
    dialog: false,
    dialogDelete: false,
    formModel: {},
    mode: "", // มีได้ 2 แบบคือ create กับ edit

    itemsListStatus: [{ Status: "Active" }, { Status: "UnActive" }],
  }),
  components: {},
  computed: {
    formTitle() {
      return this.mode === "create" ? "Add" : "Edit";
    },
  },
  async mounted() {
    //init here
    this.renderUI();
  },
  methods: {
    Back() {
      this.$router.go(-1);
    },
    async renderUI() {
      try {
        const q = {};
        var res = await feathersClientUOA
          .service("filevideo")
          .find({ query: q });
        this.items = res.data;
      } catch (error) {
        console.log(error);
        alert("ไม่สามารถขอข้อมูลจาก server ได้");
      }
    },
    async addItem() {
      this.mode = "create";
      this.formModel = Object.assign({}, this.defaultValue);
      this.dialog = true;
    },

    async editItem(item) {
      this.mode = "edit";
      this.formModel = Object.assign({}, item);
      this.dialog = true;
    },
    async deleteItem(item) {
      this.formModel = Object.assign({}, item);
      this.dialogDelete = true;
    },

    closeDialog() {
      this.dialog = false;
      this.dialogDelete = false;
    },
    async saveToServer() {
      this.loading = true;
      if (this.mode === "edit") {
        try {
          let dataEdit = {
            v_name: this.formModel.v_name,
            v_file_name: this.formModel.v_file_name,
            v_second: this.formModel.v_second,
            v_active: this.formModel.v_active,
          };
          await feathersClientUOA
            .service("filevideo")
            .patch(this.formModel.v_id, dataEdit);
          this.renderUI();
        } catch (err) {
          console.log(err);
        } finally {
          this.loading = false;
        }
      } else {
        //Add Data
        try {
          let dataAdd = {
            v_name: this.formModel.v_name,
            v_file_name: this.formModel.v_file_name,
            v_second: this.formModel.v_second,
            v_active: this.formModel.v_active,
          };
          await feathersClientUOA.service("filevideo").create(dataAdd);
          this.renderUI();
        } catch (err) {
          console.log(err);
        } finally {
          this.loading = false;
        }
      }
      this.closeDialog();
    },
    async deleteToServer() {
      this.loading = true;
      try {
        let dataDelete = {
          mb: "GEM 2",
          md: new Date(),
          retire: 1,
        };
        await feathersClientUOA
          .service("filevideo")
          .remove(this.formModel.v_id, null);
        this.renderUI();
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
        this.dialogDelete = false;
      }
    },
    uploadDone(uploadInfo) {
      this.formModel.tsd_photo_url = uploadInfo.url;
    },
  },
};
</script>